import React, { FC } from "react"
import {Props, DefaultInputComponentProps } from "react-phone-number-input"
import PhoneInput from "react-phone-number-input/input"
import forwardInput from "@components/input/manual/forwardInput"
import clsx from "clsx"

interface CustomPhoneInputProps extends Props<DefaultInputComponentProps> {
  error?: any
}

export const PhoneNumberInput: FC<CustomPhoneInputProps> = ({
  value,
  placeholder,
  error,
  onChange,
  className,
  onBlur,
}) => {
  return (
    <div className={clsx("phone_input", className)}>

      <PhoneInput
        // @ts-ignore
        inputComponent={forwardInput}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        defaultCountry="ID"
        onBlur={onBlur}
        className={clsx(error && "phone_input--error")}
      />
      <small className="text-red">{error}</small>
    </div>
  )
}
